import { axiosPost } from '@/utils/httpUtil'
import { API_URL } from '@/utils/constant/app.constants'

/**
 * @description: httpCommApiAuthDlvyLogin (배달기사 로그인)
 * @param {string} userId 사용자ID
 * @param {string} passwd 비밀번호
 * @param {string} dvicId 디바이스ID
 * @param {string} dvicModelNm 디바이스 모델명
 * @param {string} dvicFltfNm 디바이스 플랫폼명
 * @param {string} dvicFltfNmVer 디바이스 플랫폼 버전
 * @param {string} appPkgVer 앱 패키지 버전
 * @param {string} appId 앱ID
 * @param {string} joinCd 가입코드
 */
export const httpCommApiAuthDlvyLogin = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/auth/dlvy-login',
    data: pdata
  })
}
